import { registerSW as registerWorkboxSW } from 'virtual:pwa-register';

export function registerSW() {
  if (import.meta.env.DEV) return;
  registerWorkboxSW({
    immediate: true,
    onRegisteredSW(_swUrl, registration) {
      // Periodically check for updates while a tab is open.
      setInterval(() => registration?.update(), 60 * 60 * 1000);
    },
  });
}
